import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars";
import Loading from "../../system/components/Loading";
import ReactTable from "react-table";
import checkboxHOC from "react-table/lib/hoc/selectTable";
import Aux from "../../system/containers/Aux";
import Toolbar from "./components/Toolbar";
import PageHeader from "../../system/components/PageHeader";
import { WrappedTable, filterString } from "../../system/containers/Table";

import { actionCreators } from "../../store/cities";

const CheckboxTable = checkboxHOC(ReactTable);
const columns = [
  {
    accessor: "name.address",
    Header: "Cities",
    filterMethod: filterString,
    Cell: (props) => (
      <a href={"/cities/edit/" + props.original.id}>
        {props.value}{" "}
        {props.original.top_level_category &&
          props.original.top_level_category.name &&
          props.original.top_level_category.name}
      </a>
    ),
  },
  {
    accessor: "countries.value",
    Header: "Country",
    filterMethod: filterString,
    Cell: (props) => (
      <a href={"/cities/edit/" + props.original.id}>{props.value}</a>
    ),
  },
  {
    accessor: "created_at",
    Header: "Created",
    filterable: false,
    Cell: (props) => moment(props.value).format("DD/MM/YYYY"),
  },
  {
    accessor: null,
    Header: null,
    filterable: false,
    Cell: (props) => (
      <Link to={"/cities/edit/" + props.original.id}>
        <Button outline size='sm'>
          Edit
        </Button>
      </Link>
    ),
  },
];

class List extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      data: [],
    };
  }

  componentWillMount() {
    this.props.dispatch(actionCreators.fetchAll());
  }

  remove() {
    let items = this.props.selected;
    if (items.length === 0) {
      return alert("You have not selected any cities");
    }
    const result = window.confirm(
      "Are you sure you want to remove these cities?"
    );
    if (result) {
      this.props.dispatch(actionCreators.delete(items));
    }
  }

  render() {
    const { data, permissions, checkboxProps, loading } = this.props;
    if (loading) {
      return <Loading />;
    }
    return (
      <Aux>
        <PageHeader title='Destinations' />
        <Toolbar
          permissions={permissions}
          createLink={"/cities/create"}
          total={data.length}
          handleDelete={() => this.remove()}
        />
        <Scrollbars
          style={{ width: "100%", height: "100%", paddingBottom: "100px" }}
        >
          <CheckboxTable
            ref={(r) => (this.checkboxTable = r)}
            data={data}
            keyField='id'
            showPaginationBottom
            filterable
            columns={columns}
            loading={loading}
            defaultPageSize={20}
            style={{
              height: "100vh",
            }}
            className='-striped -highlight'
            {...checkboxProps}
          />
        </Scrollbars>
      </Aux>
    );
  }
}

function mapStateToProps(store) {
  return {
    permissions: store.auth.permissions,
    data: store.cities.list,
    loading: store.cities.loading,
  };
}

const WrapTable = WrappedTable(List);

export default connect(mapStateToProps)(WrapTable);



// WEBPACK FOOTER //
// ./src/containers/City/List.jsx